import * as React from 'react';
import * as styles from './TgbPrimary.css';

export interface ITgbPrimaryTemplateParams {
  type: 'tgb_primary';

  image: string;
  title: string;
  description: string;
  phone: string;
  footnote?: string;
  buttonText?: string;
  url: string;
  label?: string;
}

export const TgbPrimary = (props: ITgbPrimaryTemplateParams) => {
  const { image, title, description, phone, footnote, buttonText, url, label } = props;

  const isVisibleFooter = !!buttonText || !!footnote;

  return (
    <a
      data-testid={'TgbPrimary'}
      href={url}
      target="_blank"
      rel="nofollow noopener noreferrer"
      className={styles['container']}
    >
      <div className={styles['content']}>
        <div className={styles['image']}>
          <img src={image} alt={title} />
          {label && <div className={styles['label']}>{label}</div>}
        </div>
        <div className={styles['aside']}>
          <h4 className={styles['title']}>{title}</h4>
          <p className={styles['text']}>{description}</p>
          {phone && <div className={styles['phone']}>{phone}</div>}
        </div>
      </div>
      {isVisibleFooter && (
        <div className={styles['footer']}>
          {footnote && <div className={styles['note']}>{footnote}</div>}
          {buttonText && <div className={styles['button']}>{buttonText}</div>}
        </div>
      )}
    </a>
  );
};
